Object.defineProperty(exports, "__esModule", { value: true });
exports.TableRowCell = void 0;
const core_1 = require("@emotion/core");
const core_2 = require("@wheelroom/core");
const wheel_topic_1 = require("@wheelroom/wheel-topic");
exports.TableRowCell = (props) => {
    if (!props.topic && !props.data) {
        return null;
    }
    const dataCellStyle = props.wheel.style.td;
    if (!(dataCellStyle.ncss.w || dataCellStyle.ncss.width)) {
        dataCellStyle.ncss.w = props.dataCellWidth;
    }
    return (core_1.jsx(core_2.Td, { wheel: Object.assign(Object.assign({}, props.wheel), { style: dataCellStyle }) },
        core_1.jsx(wheel_topic_1.Topic, { data: props.data.topic, topic: props.topic, topicOptions: props.topicOptions, useHeadingElement: "p", wheel: Object.assign(Object.assign({}, props.wheel), { style: props.wheel.style.topic }) })));
};
//# sourceMappingURL=table-row-cell.js.map